<template>
	<div
		class="d-flex p-2 mt-2 position-relative mob-align-items-start w-100"
		:class="
			education.parser ? 'candash-red-details-box' : 'candash-blue-details-box'
		"
	>
		<img
			class="mr-3 lapicon"
			src="../../../assets/newdesign/dashboard/eduDp.svg"
			alt=""
		/>
		<img
			class="mr-2 mobicon"
			src="@/assets/mobile/dashboard/mb-eduDP.svg"
			alt=""
		/>
		<div class="d-flex justify-content-between mob-w-88 w-100">
			<div class="mob-w-95 w78 text-capitalize">
				<div
					class="bold-bluetxt"
					:class="education.institute ? '' : 'not-mention-txt'"
				>
					{{ education.institute ? education.institute : "Not Mentioned" }}
				</div>
				<div
					:class="isLaptop ? 'mt-2' : 'mt-1'"
					class="d-flex align-items-center candash-displaytxt-grey-2 fw-500"
				>
					<div
						class="mob-maxw-43 max-w35 text-truncate"
						:class="education.qualification ? '' : 'not-mention-txt'"
					>
						{{
							education.qualification
								? education.qualification
								: "Not Mentioned"
						}}
					</div>
					<div
						class="candash-dot ml-2 mr-2"
						v-if="education.degree || education.parser"
					></div>
					<div
						class="mob-maxw-43 max-w35 text-truncate"
						v-if="education.degree || education.parser"
						:class="education.degree ? '' : 'not-mention-txt'"
					>
						{{ education.degree ? education.degree : " Not Mentioned" }}
					</div>
					<div
						class="candash-dot ml-2 mr-2 mobile-cgpa-dot"
						v-if="education.fieldOfStudy  || education.parser"
					></div>
					<div
						class="max-w35 text-truncate mob-fos"
						:class="
							education.fieldOfStudy
								? education.fieldOfStudy
								: (education.parser ? 'Not Mentioned' : '') ==
										'Not Mentioned' && 'not-mention-txt'
						"
					>
						{{
							education.fieldOfStudy
								? education.fieldOfStudy
								: education.parser
								? "Not Mentioned"
								: ""
						}}
					</div>
					<div class="candash-dot ml-2 mr-2 hideinmob"></div>
					<div class="candash-displaytxt-grey-2 fw-500 hideinmob">
						<span v-if="education.gradePercentage">
							{{ education.gradePercentage }}
							%
						</span>
						<span v-else class="not-mention-txt">% Not Mentioned</span>
					</div>
				</div>
				<div
					class="w-100 text-truncate candash-displaytxt-grey-2 fw-500 mobile-breakdown-cgpa"
				>
					<span v-if="education.gradePercentage">
						{{ education.gradePercentage }}
						%
					</span>
				</div>
				<div
					:class="isLaptop ? ' mt-2 ' : ''"
					class="d-flex align-items-center job-description-subfont"
				>
					<div class="mob-maxw-0 max-w35 text-truncate">
						<span v-if="education.yearOfJoining">
							{{ formatMonthName(education.yearOfJoining) }}
						</span>
						<span v-else class="not-mention-txt"> Not Mentioned</span>
						-
						<span v-if="education.yearOfPassout">
							{{ formatMonthName(education.yearOfPassout) }}
						</span>
						<span v-else> currently studying </span>
					</div>
					<div class="candash-line ml-4 mr-4"></div>
					<div
						class="mob-maxw-0 max-w35 text-truncate"
						:class="education.location ? '' : 'not-mention-txt'"
					>
						{{ education.location ? education.location : "Not Mentioned" }}
					</div>
				</div>
			</div>
			<div class="pt-2 pr-2 laptop-ed-icons">
				<img
					@click.stop="openEdit()"
					class="mr-2 pointer blueShadow"
					src="../../../assets/newdesign/dashboard/blueEdit1.svg"
					alt=""
				/>
				<img
					@click.stop="deleteData()"
					class="mr-2 pointer blueShadow"
					src="../../../assets/newdesign/dashboard/blueDelete1.svg"
					alt=""
				/>
				<img
					v-if="education.parser"
					src="../../../assets/newdesign/dashboard/disableadd.svg"
					alt=""
				/>
			</div>
			<div
				class="mobile-ed-icons"
				@click.stop="$emit('select-card', education.uniqueID)"
			>
				<img src="@/assets/newbuilder/threedots.svg" alt="" />
				<div
					class="ed-box"
					v-if="selectedCard == education.uniqueID"
					:ref="'cardopen' + education.uniqueID"
				>
					<div
						class="ed-box-option d-flex align-items-center pl-2 pointer"
						@click.stop="openEdit()"
					>
						<img src="@/assets/newbuilder/ddedit.svg" class="mr-2" alt="" />Edit
					</div>
					<div
						class="ed-box-option d-flex align-items-center pl-2 pointer"
						@click="deleteData()"
					>
						<img
							src="@/assets/newbuilder/delete.svg"
							class="mr-2"
							alt=""
						/>Delete
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { formatMonthNameShort } from "../../../controllers/dashboard/helpers.js";
export default {
	name: "EducationCard",
	data() {
		return {};
	},
	mounted() {
		document.addEventListener("click", this.clickon);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.clickon);
	},
	props: {
		selectedCard: String,
		education: Object,
		isLaptop: Boolean,
		formConfiguration: Object,
		form: Object,
	},
	methods: {
		eduQualification(data) {
			const foundObject =
				this.formConfiguration.education.keys.qualification.options.find(
					(obj) => obj.value === data
				);
			return foundObject ? foundObject.text : null;
		},
		clickon() {
			let id = "cardopen" + this.education.uniqueID;
			if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
				this.$emit("select-card", "");
			}
		},
		formatMonthName(inputDate) {
			return formatMonthNameShort(inputDate);
		},

		openEdit() {
			this.$emit("edit-form", {
				form: this.form,
				content: this.education,
				id: this.education.uniqueID,
			});
		},
		deleteData() {
			this.$emit("delete-data", {
				form: this.form,
				content: this.education,
			});
		},
	},
};
</script>

<style></style>
